<template>
    <v-row justify="center">
        <v-dialog
            v-model="selectCompanion"
            :persistent='true'
            width="45%"
            height="100%"
            class="modalDialog"
            no-click-animation
        >
            <div class="memberAdd">
            <v-card class="cardWrap">
                <CardTitle title="同伴者リスト" />
                    <v-row class="mx-1">
                        <v-text-field
                            ref="formPlayerName"
                            v-model="addPlayerInfo.player_name"
                            class="px-3 mt-4"
                            width="45%"
                            height="10%"
                            :rules="[rules.required_family_name]"
                            label="姓名"
                            required
                            maxlength="100"
                        />
                        <v-text-field
                            ref="formMobileNumber"
                            v-model="addPlayerInfo.mobile_number"
                            class="px-3 mt-4"
                            width="45%"
                            height="10%"
                            label="携帯番号"
                            :rules="[rules.format_mobile_number, rules.max_length_mobile_number]"
                        />
                    </v-row>
                    <v-row class="mx-1">
                        <v-text-field
                            ref="formEmail"
                            v-model="addPlayerInfo.email"
                            class="px-3"
                            width="90%"
                            height="10%"
                            label="メールアドレス"
                            :rules="[rules.format_email, rules.max_length_email]"
                        />
                        <v-btn color="primary" class="px-3" @click="OnAddButton">追加</v-btn>
                    </v-row>
                    <div class="confirm_wording" v-if="errDialog">
                        <p class="text-center mb-4 errorMessage">{{ valid.message }}</p>
                    </div>
                    <v-data-table
                        :headers="headers"
                        :items="companionPlayerSelectList"
                        class="px-3"
                        width="100%"
                        height="70%"
                        hide-default-footer
                        disable-pagination
                        >
                        <template v-slot:[`item.deleteBtn`]="{ item }">
                            <v-btn
                                small
                                color="error"
                                @click="OnDeleteButton(item)"
                                class="editBtn"
                                :disabled="item.deleteBtnDisable">削除
                            </v-btn>
                        </template>
                    </v-data-table>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-4" text @click="CloseDialog">閉じる</v-btn>
                </v-card-actions>
            </v-card>
            <AddOverlay
                page-name="同伴者リスト"
                @processing="RegistPlayer"
                @cancel="closeAddOverLay"
                :process-result="process"
                :OverlaySwitch="addOverlay"
            />
            <RemoveOverlay
                page-name="同伴者リスト"
                @processing="RegistPlayer"
                @cancel="closeRemoveOverlay"
                :process-result="process"
                :OverlaySwitch="removeOverlay"
            />
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import AddOverlay from '@/views/Master/page/overlay/AddOverlay';
import RemoveOverlay from '@/views/Master/page/overlay/RemoveOverlay';
import { GET_COMPANION_PLAYER_LIST, REGIST_COMPANION_LIST } from '../../../constants/companion_lists';
import { GET_SETTING_VALUE } from '../../../constants/system_master';
import validater from '@/lib/validater';

export default {
    components: {
        CardTitle,
        AddOverlay,
        RemoveOverlay
    },
    data () {
        return {
            // テーブルのヘッダー
            headers: [
                { text: '名前', value: 'player_name', sortable: false, width: '45%' },
                { text: '携帯番号', value: 'mobile_number', sortable: false, width: '45%' },
                { text: '', value: 'deleteBtn', sortable: false, width: '10%' }
            ],
            selectCompanion: false,
            addOverlay: false,
            removeOverlay: false,
            // 予約番号
            reserveNo: '',
            // 最大プレーヤー番号
            nextPlayerNo: 0,
            // 友達リスト
            companionPlayerSelectList: [],
            // 代表者会員番号
            loginUserMemberNo: '',
            // 代表者データ
            representative: [],
            // 組合せ登録者リスト（削除不可の対象となる）
            selectedPlayer: [],
            count: null,
            // 入力値
            addPlayerInfo: {
                player_name: null,
                given_name: null,
                mobile_number: null,
                email: null,
                friend_flag: 0,
                valid_flag: 1
            },
            // 登録用データ
            playerInfo: [],
            // バリデーション
            valid: {
                player_name: false,
                message: ''
            },
            // 処理結果
            processing: false,
            process: {
                result: '',
                resultText: ''
            },
            deleteMessage: '',
            errDialog: false,
            loadingCount: 0,
            index: 0,
            rules: {
                // 氏名（姓）バリデーション
                required_family_name: value => !!value || this.$t('error.validation.required.familyName'),
                // メールアドレスバリデーション
                format_email: value => (value === '' || value === null || !!validater.checkMail(value)) || this.$t('error.validation.mailFormat'),
                max_length_email: value => (value === '' || value === null || value.length <= 256) || this.$t('error.validation.length.mail'),
                // 携帯番号バリデーション
                format_mobile_number: value => (value === '' || value === null || !!validater.checkmobilenumberNoHyphen(value)) || this.$t('error.validation.mobileNumber'),
                max_length_mobile_number: value => (value === '' || value === null || value.length <= 11) || this.$t('error.validation.length.mobileNumber')
            },
            emailDisb: false,
            mobileNumberDisb: false
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.loadingCount = 0;
        },
        /** ----------------------------------------------
        * 同伴者一覧取得
        * 現在の予約に対する登録同伴者の一覧を取得する
        * @param loginUserMemberNo 代表者会員番号
        * ---------------------------------------------- */
        GetCompanionList: async function (reserveNo, loginUserMemberNo, count, index, representative, selectedPlayer) {
            var me = this;
            try {
                this.$store.commit('loading/setIsOpacityLoading', true);
                // データ初期化
                this.dataClear();
                // パラメータ保存
                this.reserveNo = reserveNo;
                this.loginUserMemberNo = loginUserMemberNo;
                this.count = count;
                this.index = index;
                this.representative = representative;
                this.selectedPlayer = selectedPlayer;
                // メールor携帯番号での登録機能の使用有無を取得
                this.emailDisb = await this.GetSettingValue('companion_setting', 'companion_email');
                this.mobileNumberDisb = await this.GetSettingValue('companion_setting', 'companion_mobile');
                // 同伴者リスト一覧を取得
                this.$apollo.query({
                    query: GET_COMPANION_PLAYER_LIST,
                    fetchPolicy: 'no-cache',
                    variables: {
                        reserve_no: reserveNo
                    }
                }).then(res => {
                    this.playerList = [];
                    var count = 0;
                    this.nextPlayerNo = Math.max.apply(0, res.data.GetCompanionPlayerListFromAdmin.CompanionLists.map(function (o) { return o.player_no; })) + 1;
                    for (let player of res.data.GetCompanionPlayerListFromAdmin.CompanionLists) {
                        let deleteFlag = this.CheckSelectedPlayer(selectedPlayer, player);
                        if (player.valid_flag !== 0) {
                            this.companionPlayerSelectList.push({
                                // idは友達選択画面のidと同一値の場合、挙動が不安定のため10000を足し一致しないようにする
                                id: player.player_no + 10000,
                                friend_id: player.friend_id,
                                reserve_no: player.reserve_no,
                                player_no: player.player_no,
                                member_no: player.member_no,
                                player_name: player.player_name,
                                mobile_number: player.mobile_number,
                                email: player.email,
                                friend_flag: player.friend_flag,
                                add_friend_flag: 0,
                                valid_flag: player.valid_flag,
                                pts_reserve_no: player.pts_reserve_no,
                                deleteBtnDisable: deleteFlag
                            });
                            if (player.pts_reserve_no) {
                                count++;
                            }
                        }
                    }
                    this.selectNumber = count;
                    this.$store.commit('loading/setIsOpacityLoading', false);
                });
            } catch (error) {
                me.process.resultText = error;
                this.$store.commit('loading/setIsOpacityLoading', false);
            }
        },
        /** ----------------------------------------------
        * 同伴者画面で選択されたプレーヤーは削除不可に設定する
        * ---------------------------------------------- */
        CheckSelectedPlayer (selectedPlayer, player) {
            let playerName = player.player_name;
            let dataExist = selectedPlayer.find(ele => ele.replaceName === playerName.replace(/\s+/g, '') && ele.mobile_number === player.mobile_number && ele.email === player.email);
            if (!dataExist) {
                return false;
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
         * 追加ボタン押下
         * ---------------------------------------------- */
        OnAddButton () {
            // 入力チェック
            let validateFlag = true;
            this.errDialog = false;
            if (this.$refs.formPlayerName.validate()) {
                if (this.addPlayerInfo.mobile_number !== null && this.addPlayerInfo.mobile_number !== '') {
                    if (this.$refs.formMobileNumber.validate()) {
                    } else {
                        validateFlag = false;
                    }
                } else {
                    // this.mobileNumberErrClear();
                }
                if (this.addPlayerInfo.email !== null && this.addPlayerInfo.email !== '') {
                    if (this.$refs.formEmail.validate()) {
                    } else {
                        validateFlag = false;
                    }
                } else {
                    // this.emailErrClear();
                }
            } else {
                validateFlag = false;
            }
            if (validateFlag) {
                // 重複チェック
                if (this.CheckDuplicate(this.addPlayerInfo.player_name, this.addPlayerInfo.mobile_number, this.addPlayerInfo.email)) {
                    this.playerInfo = [];
                    this.playerInfo.push({
                        represent_member_no: this.loginUserMemberNo,
                        reserve_no: this.reserveNo,
                        player_no: this.nextPlayerNo,
                        member_no: null,
                        friend_id: 0,
                        player_name: this.addPlayerInfo.player_name,
                        family_name: this.representative.family_name,
                        given_name: this.representative.given_name,
                        mobile_number: this.addPlayerInfo.mobile_number,
                        email: this.addPlayerInfo.email,
                        friend_flag: 0,
                        add_friend_flag: 0,
                        valid_flag: this.addPlayerInfo.valid_flag
                    });
                    this.addOverlay = true;
                    // this.RegistPlayer(playerInfo);
                } else {
                    this.valid.message = '既に同姓同名の方が登録されています。';
                    this.valid.player_name = true;
                    this.errDialog = true;
                }
            } else {
            }
        },
        /** ----------------------------------------------
         * 削除ボタン押下
         * ---------------------------------------------- */
        OnDeleteButton (player) {
            this.playerInfo = [];
            this.playerInfo.push({
                represent_member_no: this.loginUserMemberNo,
                reserve_no: player.reserve_no,
                player_no: player.player_no,
                member_no: player.member_no,
                friend_id: player.friend_id,
                player_name: player.player_name,
                family_name: this.representative.family_name,
                given_name: this.representative.given_name,
                mobile_number: player.mobile_number,
                email: player.email,
                friend_flag: player.friend_flag,
                add_friend_flag: player.add_friend_flag,
                valid_flag: 0
            });
            this.removeOverlay = true;
            // this.RegistPlayer(playerInfo);
        },
        /** ----------------------------------------------
         * 削除ボタン押下
         * ---------------------------------------------- */
        RegistPlayer () {
            try {
                this.loadingOn();
                this.$apollo.mutate({
                    mutation: REGIST_COMPANION_LIST,
                    variables: {
                        CompanionPlayerList: this.playerInfo
                    }
                }).then(res => {
                    this.GetCompanionList(this.reserveNo, this.loginUserMemberNo, this.count, this.index, this.representative, this.selectedPlayer);
                    this.addPlayerInfo = {
                        player_name: null,
                        given_name: null,
                        mobile_number: null,
                        email: null,
                        valid_flag: 1
                    };
                    if (this.removeOverlay) {
                        this.removeOverlay = false;
                    } else {
                        this.addOverlay = false;
                    }
                    this.loadingOff();
                });
            } catch (error) {
                this.process.resultText = error;
                this.loadingOff();
            }
        },
        /** ----------------------------------------------
         * データ初期化
         * ---------------------------------------------- */
        dataClear () {
            this.representative = [];
            this.selectedPlayer = [];
            this.companionPlayerSelectList = [];
        },
        // /** ----------------------------------------------
        //  * バリデーション初期化
        //  * ---------------------------------------------- */
        // mobileNumberErrClear () {
        //     if (this.addPlayerInfo.mobile_number === null || this.addPlayerInfo.mobile_number === '') {
        //         // this.addPlayerInfo.mobile_number = '';
        //         this.$refs.formMobileNumber.reset();
        //     }
        // },
        // emailErrClear () {
        //     if (this.addPlayerInfo.email === null || this.addPlayerInfo.email === '') {
        //         // this.addPlayerInfo.email = '';
        //         this.$refs.formEmail.reset();
        //     }
        // },
        /** ----------------------------------------------
         * 閉じるボタン押下
         * ---------------------------------------------- */
        CloseDialog () {
            this.companionPlayerSelectList = [];
            this.selectCompanion = false;
            this.$emit('close-select-companion');
        },
        /** ----------------------------------------------
         * 確認ダイアログを閉じる
         * ---------------------------------------------- */
        closeAddOverLay () {
            this.$set(this.process, 'result', '');
            this.addOverlay = false;
        },
        closeRemoveOverlay () {
            this.$set(this.process, 'result', '');
            this.removeOverlay = false;
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function () {
            this.loadingCount--;
            if (this.loadingCount === 0) {
                this.selectCompanion = true;
            }
        },
        /** ----------------------------------------------
         * SettingValueを取得
         * ---------------------------------------------- */
        GetSettingValue: async function (settingGroup, settingKey) {
            var me = this;
            try {
                this.loadingOn();
                var res = await this.$apollo.query({
                    query: GET_SETTING_VALUE,
                    fetchPolicy: 'no-cache',
                    variables: {
                        settingGroup: settingGroup,
                        settingKey: settingKey
                    }
                });
                me.loadingOff();
                return Boolean(res.data.GetSettingValue.setting_value);
            } catch (error) {
                me.process.resultText = error;
                me.loadingOff();
            }
        },
        /** ----------------------------------------------
         * 重複チェック
         * ---------------------------------------------- */
        CheckDuplicate: function (playerName, mobileNnumber, email) {
            for (let player of this.companionPlayerSelectList) {
                // 有効フラグ0は削除されているので除外
                if (player.valid_flag !== 1) {
                    continue;
                }
                if (player.player_name.replace(/\s+/g, '') === playerName.replace(/\s+/g, '')) {
                    // 携帯番号入力が可能の場合
                    if (this.mobileNumberDisb) {
                        // どちらもデータが無ければ一致として判断
                        if ((player.mobile_number === null && mobileNnumber === null) || (player.mobile_number === '' && mobileNnumber === '')) {
                            return false;
                        }
                        // playerListのデータがあって、一致していれば
                        if ((player.mobile_number === mobileNnumber && player.mobile_number)) {
                            return false;
                        }
                    }
                    // Eメール入力が可能の場合
                    if (this.emailDisb) {
                        // どちらもデータが無ければ一致として判断
                        if ((player.email === null && email === null) || (player.email === '' && email === '')) {
                            return true;
                        }
                        // playerListのデータがあって、一致していれば
                        if (player.email === email && player.email) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }
    }
};
</script>

<style scoped>
.v-data-table{
    overflow: hidden;
    overflow-y: scroll;
    display: block;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
}
.confirm_header {
    width: 600px;
    height: 40px;
    font-size: 1.2rem;
    font-weight: bold;
    margin: 20px 20px 0 20px;
    padding-top: 6px;
    padding-left: 30px;
    padding-right: 30px;
    background: #c9e5ef;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
.confirm_wording {
    display: table-cell;
    vertical-align: middle;
}
.confirm_table {
    display: table;
}
.confirmDialog {
    margin: 0 20px 0 20px;
    width: 600px;
    background: #ffffff;
    padding: 30px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.dialogContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.errorMessage {
    color: #990000;
}
</style>
